import { createContext, useContext } from 'react';
import { ServiceState } from '../../rz-status_models';

type FilterContextType = {
  filter: ServiceState[];
  setFilter: (values: ServiceState[]) => void;
};

export const FilterContext = createContext<FilterContextType | undefined>(undefined);

export const useFilter = () => {
  const context = useContext(FilterContext);
  if (!context) throw new Error('useFilter must be used within a FilterProvider');
  return context;
};